import React from 'react';
import styles from './styles.module.scss';
import Text from '@profile/src/Components/Text';
import { formatCurrency } from '@wolffun/system-currency';
import { getTimeSince } from '@profile/src/utils/date';
import { formatType } from '../../utils';
import classNames from 'classnames';

const ListItemDesktop = ({
  data,
  boxConfig
}) => {
  const renderItem = item => {
    var _item$boxPurchaseEven;

    const box = boxConfig[item.boxType];
    return /*#__PURE__*/React.createElement("div", {
      key: item.id.toString(),
      className: styles.item
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.wrapBox
    }, /*#__PURE__*/React.createElement("img", {
      className: styles.boxImg,
      src: box.imgPath
    }), /*#__PURE__*/React.createElement("span", {
      className: styles.value
    }, box.name, " Box")), /*#__PURE__*/React.createElement("div", {
      className: styles.wrapValue
    }, /*#__PURE__*/React.createElement(Text, {
      numberOfLines: 1,
      className: styles.type
    }, formatType(item.source)), /*#__PURE__*/React.createElement(Text, {
      numberOfLines: 1,
      className: classNames(styles.status, styles.completed)
    }, "Completed")), /*#__PURE__*/React.createElement("div", {
      className: styles.wrapValue
    }, !!item.boxPurchaseEvent && /*#__PURE__*/React.createElement(Text, {
      className: styles.value
    }, formatCurrency((_item$boxPurchaseEven = item.boxPurchaseEvent) === null || _item$boxPurchaseEven === void 0 ? void 0 : _item$boxPurchaseEven.price, {
      withCurrency: true,
      trimWholeFraction: true
    })), !!item.timestamp && /*#__PURE__*/React.createElement(Text, {
      className: styles.subValue
    }, getTimeSince(new Date(item.timestamp * 1000)))));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, data.map(renderItem));
};

export default ListItemDesktop;